import PageWrapper from "../../PageWrapper";
import {ReactNode, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import QRCodeApi from "../../../api/qr-code/QRCodeApi";
import QRCode from "../../../api/qr-code/QRCode";
import Notifications from "../../../utils/notifications/Notifications";
import QRCodeDetailsContext from "./QRCodeDetailsContext";
import useFetching from "../../../hooks/useFetching";
import SummaryCard from "./cards/summary/SummaryCard";

type QueryParams = {
    id: string;
}

function QRCodeDetails() {
    /**
     * Query params from URL.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const queryParams = useParams<QueryParams>();

    /**
     * QRCode from API.
     * Will be fetched at reload() method.
     * Possible undefined.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const [qrCode, setQrCode] = useState<QRCode>();

    /**
     * Is actually fetching?
     * @author Kacper Faber
     * @since 0.1.8
     */
    const [isFetching, startFetching, stopFetching] = useFetching(false);

    /**
     * Reload data from API.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const reload = () => {
        if (!queryParams.id) {
            setQrCode(undefined);
            return;
        }

        startFetching();

        QRCodeApi.getById(queryParams.id)
            .then(setQrCode)
            .catch(Notifications.onFetchError)
            .finally(stopFetching);
    };

    /**
     * Wraps your children inside a QRCodeDetailsContext.
     * @param children
     * @author Kacper Faber
     * @since 0.1.8
     */
    const wrapContext = (children: ReactNode) => {
        return (
            <QRCodeDetailsContext.Provider
                value={{qrCode, isFetching}}
                children={children}
            />
        );
    }

    /**
     * Call reload() if ?id changed.
     * @author Kacper Faber
     * @since 0.1.8
     */
    useEffect(reload, [queryParams.id]);

    return wrapContext(
        <PageWrapper container>
            <SummaryCard/>
        </PageWrapper>
    );
}

export default QRCodeDetails;

// TODO: QRCodeDetails.tsx
//  Implement 'container' system
//  Create and add some new cards